import { render, staticRenderFns } from "./ModalLocked.vue?vue&type=template&id=49fd7ad0&"
import script from "./ModalLocked.vue?vue&type=script&lang=js&"
export * from "./ModalLocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports